// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_z-1";
export var movingGradient = "_z-4";
export var movingGradientBlock = "_z-2";
export var skeleton = "_z-0";
export var skeletonText = "_z-3";